// API'deki sıralamanın (api → routes/public.ts, byBranchRank) birebir aynısı: şubenin sıraladıkları
// kendi sırasıyla önce, sıralanmamışlar markanın sırasıyla sona. Panel başka bir kural uygularsa
// kullanıcı menüde gördüğünden farklı bir liste sürükler.
export const byBranchRank = (items, rankOf) =>
  items
    .map((item, index) => ({ item, index, rank: rankOf(item) ?? null }))
    .sort((a, b) => {
      if (a.rank === null || b.rank === null) {
        return a.rank === b.rank ? a.index - b.index : a.rank === null ? 1 : -1;
      }

      return a.rank - b.rank;
    })
    .map((entry) => entry.item);

// Sürüklenen öğeyi hedefin bulunduğu yere taşı. Liste sayfalanmış/filtrelenmiş olsa bile TAM liste
// üzerinden hesaplanır: kullanıcı ekranda gördüğü komşunun yanına bırakır, sıra da gerçekte oraya
// yazılır.
export const moveBeside = (items, activeId, overId) => {
  const from = items.findIndex((item) => item.id === activeId);
  const to = items.findIndex((item) => item.id === overId);

  if (from === -1 || to === -1 || from === to) {
    return items;
  }

  const next = [...items];
  const [moved] = next.splice(from, 1);

  next.splice(to, 0, moved);

  return next;
};
